/* eslint-disable jsx-a11y/alt-text */
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Text from "components/Common/Text";
import { motion } from "framer-motion";
import { Separator } from "../components/scorecardItem/Separator";
import { MatchPlayTeamResultsCard } from "./MatchPlayTeamResultsCard";
import { MatchPlayTeamResultsTable } from "./MatchPlayTeamResultsTable";

export function ResultsPending({ title, gifTheme }) {
  const giphy = {
    baseURL: "https://api.giphy.com/v1/gifs/",
    apiKey: "ClsKX9UizJ1i0n6zHOJEQtzvowKZmME5",
    tag: gifTheme || "playing golf",
    type: "random",
    rating: "G",
  };

  const [gif, setGif] = useState(null);

  const fetchGiphy = async () => {
    // eslint-disable-next-line max-len
    const url = `${giphy.baseURL}${giphy.type}?api_key=${giphy.apiKey}&tag=${giphy.tag}&rating=${giphy.rating}`;
    const response = await fetch(url);
    const data = await response.json();
    setGif(data.data.images.downsized.url);
  };

  useEffect(() => {
    fetchGiphy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ position: "relative", padding: 20 }}>
      <div>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            width: "100%",

            mixBlendMode: "luminosity",
          }}
          className="animation-container"
        >
          <Text
            as="H1"
            bold
            ta="center"
            mt={10}
            style={{
              color: "white",
              fontWeight: "700",
              letterSpacing: -2,
              fontSize: 32,
            }}
          >
            {title || "Results Pending"}
          </Text>
        </div>
      </div>
      <motion.img
        style={{
          height: "100%",
          width: "100%",
          imageOrientation: "inherit",
          backgroundSize: "cover",
          objectFit: "cover",
          objectPosition: "center",
          opacity: 1,
        }}
        src={gif}
        alt=""
      />
    </div>
  );
}

ResultsPending.propTypes = {
  title: PropTypes.string.isRequired,
  gifTheme: PropTypes.string.isRequired,
};

export function MultipleTeeTimeMatchPlayTab({ teamsData, ball2 }) {
  const style = {
    display: "flex",
    flexDirection: "row",
    padding: 20,
    overflowX: "scroll",
    width: "100%",
    whiteSpace: "nowrap",
  };

  const isMatchFinded = teamsData?.find((team) => team.data.matches);

  const hideYourTeamComparisonSercionForGuest = teamsData.some(
    (player) => player.playerTeam,
  );

  return !isMatchFinded ? (
    <ResultsPending />
  ) : (
    <>
      <Separator showTime teeTimeString="RESULTS" />
      <div style={style}>
        {teamsData
          .filter((team) => team.data.matches)
          .sort((a, b) => {
            if (a.teamName < b.teamName) {
              return -1;
            }
            if (a.teamName > b.teamName) {
              return 1;
            }
            return 0;
          })
          .map((team) => (
            <MatchPlayTeamResultsCard
              key={team.teamName}
              active={team.playerTeam}
              score={
                ball2
                  ? team.data.ball2 ?? team.data.ways
                  : team.data.ball1 ?? team.data.ways
              }
              teamName={team.teamName}
            />
          ))}
      </div>
      {hideYourTeamComparisonSercionForGuest && (
        <>
          <Separator showTime teeTimeString="TEAM COMPARISON" />
          <MatchPlayTeamResultsTable teamsData={teamsData} ball2={ball2} />
        </>
      )}
    </>
  );
}

MultipleTeeTimeMatchPlayTab.propTypes = {
  ball2: PropTypes.bool.isRequired,
  teamsData: PropTypes.shape({
    sort: PropTypes.func,
    filter: PropTypes.func,
    find: PropTypes.func,
    some: PropTypes.func,
  }).isRequired,
};
